import {React} from "react";
import Chart from "react-apexcharts";

const CategoricalBarChartJumbos = ({dataSeries, loading, multTonelaje, numCategorias}) => {

  const options = {
    debug: true,
    noData: {
      text: "No hay datos",//dataSeries.percutido.length < 1 ?"Cargando ..." : "No hay datos",
      offsetX: 70,
      offsetY: -20,
      style: {
        color: "#2f4554"/* "#00b7c4" */,
        fontSize: '14.4px',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      }
    },
    grid: {
      position: 'back'
    },
    legend:{
      hide:true,
      position: "bottom",
      horizontalAlign: "right",
      offsetY: 10
    },
    colors: ["#2f4554"],
    chart: {
      toolbar:{show:false},
      defaultLocale: 'en',
      locales: [{
        name: 'en',
        options: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          days: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
          shortDays: ['Dom','Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
          toolbar: {
            download: 'Descargar SVG',
            selection: 'Selección',
            selectionZoom: 'Selección Zoom',
            zoomIn: 'Zoom',
            zoomOut: 'Alejar',
            pan: 'Panning',
            reset: 'Reset Zoom',
          }
        }
      }],
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        columnWidth: '50%',
        colors: {
          backgroundBarColors: dataSeries?.categorias.map(el => "#f5f5f5")//["#f5f5f5"],
        },
      },
    },
    dataLabels: {
      enabled: false,
      style:{
        colors: ['#f5f5f5']
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: dataSeries?.categorias,
      labels:{
        style: {
          fontWeight: "bold",
      },
      }
    },
    yaxis: [
      {
        labels: {
          formatter: function(val) {
            return `${Math.floor(val)}`
          }
        },
        min: 0,
        max: (Math.max(...dataSeries?.percutido)) ? Math.max(...dataSeries?.percutido)+2 : 5,
      }
    ],
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val}`
        }
      }
    }
  };
  
  return (
    <div id="chartbar">
      <Chart 
        height={"250px"} 
        width={"100%"} 
        options={options} 
        series={
          [
            {
              name: "Percutido",
              data: dataSeries?.percutido
            }
          ]
        } 
        type="bar" 
      />
    </div>
  );
  
}

export default CategoricalBarChartJumbos;